



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game, GameLog } from '@/class/game'
import { GameState } from '@/enum'
import RoleComingOutMessage from './RoleComingOutMessage.vue'
import ProclaimPoliceResultMessage from './ProclaimPoliceResultMessage.vue'
import ProclaimInvestigatorResultMessage from './ProclaimInvestigatorResultMessage.vue'
import VoteLog from './VoteLog.vue'
import Night from './Night.vue'
import NightActionResult from './NightActionResult.vue'
import TakeOtherResultMessages from './TakeOtherResultMessages.vue'
import HeadlineDot from '@/components/Utils/headline/HeadlineDot.vue'

@Component({
  components: {
    RoleComingOutMessage,
    ProclaimPoliceResultMessage,
    ProclaimInvestigatorResultMessage,
    VoteLog,
    Night,
    NightActionResult,
    TakeOtherResultMessages,
    HeadlineDot
  }
})

export default class LogViewer extends Vue {
  @Prop() game!: Game;
  @Prop() logs!: GameLog[];
  @Prop() playerId!: string

  get logsOfDays (): GameLog[][] {
    const logsOfDays: GameLog[][] = []
    for (const log of this.logs) {
      logsOfDays[log.day] ? logsOfDays[log.day].push(log) : logsOfDays[log.day] = [log]
    }
    return logsOfDays
  }

  checkStateIsNight (state: GameState) {
    return state === GameState.night || state === GameState.firstNight
  }

  get isFullclose () {
    return this.game.settings.isFullclose
  }
}
